import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationServiceOnboardPostBody,
  IConfigurationServiceOnboardResponse,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useCurlLogger } from "../../useCurlLogger";
type InventoryTaxCreateAPIResponse = { status: boolean; message: string; subServiceId?: string | null };

AxiosCurlirize(axios, () => {});
export const useConfigurationServiceOnboardAPI = () => {
  const [newServiceId, setNewServiceId] = useState<string>("");
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (formData: IConfigurationServiceOnboardPostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!formData) {
          return;
        }
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(
            `${CONFIGURATION_APIS?.SERVICE_ONBOARD?.baseURL}`,
            formData,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IConfigurationServiceOnboardResponse>) => {
            if (res.data.status) {
              const responseData = (res.data as any)?.data || {};
              const serviceId = responseData?.service_id ?? null;
              const subServiceId =
                responseData?.sub_service_id ??
                responseData?.subServiceId ??
                responseData?.service_details?.sub_service_id ??
                responseData?.sub_service_details?.sub_service_id ??
                null;
              toast.success(`${formData?.service_details?.service_name} has been on boarded successfully.`);
              return { status: true, message: serviceId, subServiceId };
            } else {
              toast.error("Error while onboarding service.");
              return { status: false, message: null, subServiceId: null };
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            sendCurl(e.config["curlCommand"]);
            return { status: false, message: null, subServiceId: null };
          });
        return response;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.response.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
          if (axiosError.response.status === 400) {
            const response = axiosError.response as any;
            toast.error(response.data.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { newServiceId, execute };
};
